import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchPaymentMethodMutation } from '../../../services'
import { UspConfigurationPaymentMethodViewResult } from '../../../models'
import PaymentPaymentMethodsTable from './components/PaymentPaymentMethodsTable'
import AddEditPaymentMethodModal from './components/AddEditPaymentMethodModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsPaymentPaymentMethods = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchPaymentMethod, { data, isLoading }] = useSearchPaymentMethodMutation()
  const [paymentMethodData, setPaymentMethodData] = useState<UspConfigurationPaymentMethodViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchPaymentMethod({
      simpleSearch: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setPaymentMethodData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Form Packs'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <>
            <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
              Add new
            </Button>
          </>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='Payment Methods' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <PaymentPaymentMethodsTable
                      loading={isLoading}
                      data={paymentMethodData}
                      setData={setPaymentMethodData}
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditPaymentMethodModal
              submit={submit}
              open={openAddEditModal}
              onClose={handleCloseModal}
              type={type}
              rowData={rowData as UspConfigurationPaymentMethodViewResult}
            />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsPaymentPaymentMethods
